export const ROLES = [
	{
		id: '1',
		label: 'Admin'
	},
	{
		id: '2',
		label: 'Editor'
	},
	{
		id: '3',
		label: 'Guest'
	}
]